import { apiClient } from '../apiClient';
import {
  DocumentDto,
  DocumentDetailsDto,
  DocumentProcessResultDto,
  RedactResponseDto,
  CountryProfilesResponseDto,
  PendingReviewsResponseDto,
  ApproveReviewResponseDto,
  CorrectReviewResponseDto,
  AuditTrailResponseDto,
  DetectionResultDto,
  FieldValueType,
} from '@shared/contracts';

export const documentsApi = {
  list: (): Promise<DocumentDto[]> => {
    return apiClient.get<DocumentDto[]>('/documents');
  },

  getJobsGroupedByUser: (): Promise<Array<{ userId: string; userEmail: string; jobsCount: number; documents: DocumentDto[] }>> => {
    return apiClient.get('/documents/by-user');
  },

  getById: (id: string): Promise<DocumentDetailsDto> => {
    return apiClient.get<DocumentDetailsDto>(`/documents/${id}`);
  },

  getCountryProfiles: (): Promise<CountryProfilesResponseDto> => {
    return apiClient.get<CountryProfilesResponseDto>('/documents/country-profiles');
  },

  getPendingReviews: (): Promise<PendingReviewsResponseDto> => {
    return apiClient.get<PendingReviewsResponseDto>('/documents/review/pending');
  },

  approveReview: (id: string): Promise<ApproveReviewResponseDto> => {
    return apiClient.post<ApproveReviewResponseDto>(`/documents/review/${id}/approve`);
  },

  correctReviewField: (id: string, fieldName: string, newValue: FieldValueType): Promise<CorrectReviewResponseDto> => {
    return apiClient.post<CorrectReviewResponseDto>(`/documents/review/${id}/correct`, {
      field_name: fieldName,
      new_value: newValue,
    });
  },

  upload: (formData: FormData): Promise<DocumentProcessResultDto> => {
    return apiClient.post<DocumentProcessResultDto>('/documents', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  redact: (id: string, items: DetectionResultDto[], mode: string = 'BLACK_BOX'): Promise<RedactResponseDto> => {
    return apiClient.post<RedactResponseDto>(`/documents/${id}/redact`, { items, mode });
  },

  getAuditTrail: (id: string): Promise<AuditTrailResponseDto> => {
    return apiClient.get<AuditTrailResponseDto>(`/documents/${id}/audit`);
  },
};
